import {
  Box,
  Heading,
  HStack,
  Image,
  Text,
  SimpleGrid,
  VStack,
} from "@chakra-ui/react";
import aiNetwork from "../assets/images/icon/ai-network.svg";
import legalDocument from "../assets/images/icon/legal-document.svg";
import robotic from "../assets/images/icon/robotic.svg";
import shieldEnergy from "../assets/images/icon/shield-energy.svg";

import validacionPreventiva from "../assets/images/agentes_inteligentes/Validacion-preventiva.webp";
import alertasRiesgo from "../assets/images/agentes_inteligentes/Alertas-de-riesgo-fiscal.webp";
import normativa from "../assets/images/agentes_inteligentes/Normativa-al-alcance.webp";
import visionIntegral from "../assets/images/agentes_inteligentes/Vision-integral-de-tu-situacion-fiscal.webp";

type CardProps = {
  title: string;
  description: string;
  image: string;
  icon: string;
};

const InfoCardItem = ({ title, description, image, icon }: CardProps) => {
  return (
    <Box
      borderRadius="32px"
      overflow="hidden"
      w="100%"
      h="420px"
      position="relative"
      backgroundImage={`url(${image})`}
      backgroundSize="cover"
      backgroundPosition="center"
      boxShadow="0px 8px 24px rgba(0,0,0,0.12)"
    >
      <Box
        position="absolute"
        bottom={0}
        left={0}
        right={0}
        bg="rgba(14, 46, 251, 0.25)"
        backdropFilter="blur(6px)"
        p={5}
      >
        <VStack align="start" spacing={2}>
          <HStack spacing={2} align="center">
            <Box>
              <Image src={icon} alt="" role="presentation" htmlWidth={32} htmlHeight={32} />
            </Box>
            <Text fontSize={{ base: "18px", md: "20px", lg: "24px" }} fontWeight="600" color="white" lineHeight="1.2">
              {title}
            </Text>
          </HStack>

          <Text fontSize={{ base: "14px", md: "16px", lg: "20px" }} fontWeight="500" lineHeight="1.5" color="white">
            {description}
          </Text>
        </VStack>
      </Box>
    </Box>
  );
};

const InfoCard = () => {
  const cards: CardProps[] = [
    {
      title: "Validación preventiva",
      description:
        "Detectan inconsistencias en tus CFDIs antes de que el SAT envíe una invitación de vigilancia profunda. Cada factura validada es un riesgo menos que gestionar.",
      image: validacionPreventiva,
      icon: aiNetwork,
    },
    {
      title: "Alertas de riesgo fiscal",
      description:
        "Identifican operaciones con proveedores en listas negras (69 y 69B) y complementos de pago incorrectos. Actúas antes de recibir un requerimiento.",
      image: alertasRiesgo,
      icon: legalDocument,
    },
    {
      title: "Normativa al alcance",
      description:
        "Consulta leyes, reglas y criterios fiscales vigentes en lenguaje claro. La respuesta correcta en un entorno privado a tus consultas.",
      image: normativa,
      icon: robotic,
    },
    {
      title: "Visión integral de tu situación fiscal",
      description:
        "CFDIs, impuestos, periodos y complementos de pago integrados en un solo lugar. Información trazable y lista para sostener cualquier revisión.",
      image: visionIntegral,
      icon: shieldEnergy,
    },
  ];

  return (
    <Box py={{ base: 10, md: 16 }} px={{ base: 4, md: "30px", lg: "60px", xl: "120px" }} bg="#F6F8FC">
      <VStack spacing={14}>
        <Heading
          as="h2"
          fontSize={{ base: "2xl", md: "38px" }}
          fontWeight="700"
          color="#0A33FF"
          textAlign="center"
          data-aos="fade-up"
        >
          Lo que los agentes inteligentes hacen por ti
        </Heading>

        <SimpleGrid columns={{ base: 1, md: 1, lg: 2 }} spacing="24px" w="100%" data-aos="fade-up" data-aos-anchor-placement="top-center">
          {cards.map((card) => (
              <InfoCardItem key={card.title} {...card} />
          ))}
        </SimpleGrid>
      </VStack>
    </Box>
  );
};

export default InfoCard;
